import { responseError } from '@/utils/errors';
import { assignProps } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import { findCatalogue } from './state';

const fetchCatalogue = withDraft((draft, action) => {
  const item = findCatalogue(draft, action);

  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.catalogues[action.category].results.push({
      catalogue: {},
      code: action.code,
      readStatus: states.PENDING,
      readErrors: [],
    });
  }
});

const showCatalogue = withDraft((draft, action) => {
  const item = findCatalogue(draft, action);
  assignProps(item, {
    catalogue: action.result,
    readStatus: states.SUCCESS,
    readErrors: [],
  });
});

const showCatalogueError = withDraft((draft, action) => {
  const item = findCatalogue(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

export default {
  [actions.FETCH_CATALOGUE]: fetchCatalogue,
  [actions.SHOW_CATALOGUE]: showCatalogue,
  [actions.SHOW_CATALOGUE_ERROR]: showCatalogueError,
};
